module.exports = __webpack_public_path__ + "img/app_icon_web.b706e0a4.png";